import { SupplyType, Tariff } from "src/types";

export const filterOnlyTariffTypesMatchingSupplyType = (
  tariffTypesSelected: Array<{ label: string; value: string }>,
  tariffTypes: Tariff[],
  supplyType: SupplyType | null
): Array<{ label: string; value: string }> => {
  return tariffTypesSelected.reduce<Array<{ label: string; value: string }>>(
    (acc, selectedTariff) => {
      if (supplyType) {
        const tariffType = tariffTypes.find(
          (tariffType) => tariffType.tariffType === selectedTariff.value
        );
        if (tariffType && tariffType.supplyType === supplyType) {
          return acc.concat([selectedTariff]);
        } else {
          return acc;
        }
      } else {
        return acc.concat([selectedTariff]);
      }
    },
    []
  );
};

export const getTariffSelectOptionsFromTariffTypes = (
  tariffs: Tariff[]
): Array<{ label: string; value: Tariff }> => {
  return tariffs.map((tariff) => ({
    label: `${tariff.tariffType} ${
      tariff.productName ? " (" + tariff.productName + ")" : ""
    }`,
    value: tariff,
  }));
};



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/utils.ts